// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader } from "@components";

import type { State } from "@store/reducers";
import { AbsenceReviewForm } from "@modules/shared/components";
import * as selectors from "@modules/shared/selectors";
import actionCreator from "@modules/shared/actionCreator";

type OwnProps = $Exact<{
  clientId: number,
  employeeId: number,
  onCancel: () => *,
}>;

type PropsFromState = $Exact<{
  task: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  createTask: typeof actionCreator.CreateAbsenceReviewTask,
  cancelTask: typeof actionCreator.CancelAbsenceReviewTask,
  submitTask: typeof actionCreator.SubmitAbsenceReviewTask,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class MonitoringUpdateModal extends React.Component<Props> {
  reviewRef: *;

  componentDidMount() {
    this.props.createTask({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
    });
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  setReviewRef = (ref: *) => {
    this.reviewRef = ref;
  };

  submitForm = () => {
    this.reviewRef.submitForm();
  };

  handleSubmit = (formData: *) => {
    if (this.props.task) {
      this.props.submitTask({
        clientId: this.props.clientId,
        employeeId: this.props.employeeId,
        taskId: this.props.task.id,
        task: formData,
      });
    }
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.handleCancel} className="d-flex justify-content-between">
          {this.props.t("UPDATE")}
        </ModalHeader>
        <ModalBody>
          {this.props.task && (
            <AbsenceReviewForm
              onRef={this.setReviewRef}
              task={this.props.task}
              externalSubmit
              onSubmit={this.handleSubmit}
              onCancel={this.handleCancel}
              isModal
            />
          )}
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  task: selectors.getReviewTask(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  createTask: actionCreator.CreateAbsenceReviewTask,
  cancelTask: actionCreator.CancelAbsenceReviewTask,
  submitTask: actionCreator.SubmitAbsenceReviewTask,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(MonitoringUpdateModal);
